// extracted by mini-css-extract-plugin
module.exports = {"contact":"login-module--contact--1vts0","center":"login-module--center--ZzUef","formControl":"login-module--formControl--pvlDb","submit":"login-module--submit--26IDX"};